<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ "organization" | t }}</h4>
      <hr />
      <div class="row">
        <div class="col-md-4">
          <strong>{{ "current_organization" | t }}</strong>
        </div>
        <div class="col-md-8">{{ customer.organization.name }}</div>
      </div>
      <div class="mt-3 row">
        <div class="col-md-4">
          <p class="text-muted">{{ "move_organization_information" | t }}</p>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="mb-0">{{ "organization" | t }}</label>
            <select class="form-control" v-model="targetOrganization">
              <option
                v-for="organization in filteredOrganizations"
                :value="organization"
                :key="organization.id"
              >
                {{ organization.name }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="targetOrganization">
            <label class="mb-0">{{ "plan" | t }}</label>
            <select class="form-control" v-model="targetPlan">
              <option
                v-for="plan in filteredPlans"
                :value="plan"
                :key="plan.id"
              >
                {{ plan.name }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="targetOrganization && targetPlan">
            <button
              class="btn btn-outline-primary"
              @click="
                spin($event, move_organization, targetOrganization, targetPlan)
              "
            >
              {{ "move_customer_to_organization" | t }}
              {{ targetOrganization.name }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
    whitelabelOrganizations: Array,
    whitelabelPlans: Array,
  },
  data() {
    return {
      targetOrganization: null,
      targetPlan: null,
    };
  },
  computed: {
    filteredPlans() {
      return this.whitelabelPlans.filter(
        (plan) =>
          plan.organization &&
          plan.organization.id === this.targetOrganization.id
      );
    },
    filteredOrganizations() {
      return this.whitelabelOrganizations.filter(
        (organization) => organization.id !== this.customer.organization.id
      );
    },
  },
};
</script>